import fetchUser from './fetchUser';
import trackAnalytics, {isOptedOut} from './trackAnalytics';

// See https://developers.google.com/analytics/devguides/collection/analyticsjs/sending-hits
export default async function trackFormAnalytics<T extends AnalyticsEvent & {category: string}>(
    formId: string,
    name: T['analyticsEventName'],
    category: T['category']
) {

    if (isOptedOut(await fetchUser())) { return; }
    const form = document.getElementById(formId) as HTMLFormElement | null;
    if (!form) { return; }
    form.addEventListener('submit', event => {
        event.preventDefault();
        setTimeout(submitForm, 1000);
        let formSubmitted = false;
        function submitForm() {
            if (!formSubmitted && form) {
                formSubmitted = true;
                form.submit();
            }
        }
        trackAnalytics<T>(name, {category} as Omit<T, 'analyticsEventName'>, submitForm);
    });
}
